const storeLinks = {
  playStore: 'https://play.google.com/store/apps/details?id=com.thriveinapp',
  appStore: 'https://apps.apple.com/us/app/thrivein/id1534311706',
}


export default storeLinks
